import React from "react";
import "./ChristmasLights.css";

const ChristmasLights = () => {
    const lights = Array.from({ length: 40 }, (_, i) => i);

    return (
        <ul className="christmas-lights">
            {lights.map((_, index) => (
                <li key={index} />
            ))}
        </ul>
    );
};

export default ChristmasLights;
